import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useCurrentUser } from '@/features/auth/useCurrentUser';
import { FullScreenSpinner } from '@/app/layouts/FullScreenSpinner';

/**
 * Hides the admin screen from non-admins. This is a UI courtesy, not the boundary —
 * the API checks the role from the database on every request, so a non-admin reaching
 * this route by typing the URL still gets nothing back.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const me = useCurrentUser();

  if (me.isPending) return <FullScreenSpinner label="Checking access" />;
  if (!me.data?.isAdmin) return <Navigate to="/board" replace />;

  return <>{children}</>;
}
